/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//import translation function for language translation
import { useTranslation } from "react-i18next";
import CrmTaskTab from "./Tabs/CrmTaskTab";
import CrmLogTab from "./Tabs/CrmLogTab";

const CrmTaskPopup = ({
  /* module start (eg:selectedModuleSlug=MOD_LEAD) and moduleName="projecttask*/
  selectedModuleSlug = "",
  moduleName = "", // projecttask
  /* module end */

  /* select component id start */
  contactId = null,
  leadId = null,
  /* select component id end */

  /* for task details and update */
  selectedTaskId = null,
  setSelectedTaskId = () => {},
  afterPopupClose = () => {},
  onPopupClose = () => {},

  /* for alert */
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();
  const [showTaskTab, setshowTaskTab] = useState(false);
  const [showLogTab, setshowLogTab] = useState(false);
  const [isReset, setIsReset] = useState(false);

  //* Switch between task and log tab based on the tabName parameter */
  const switchTabs = (tabName) => {
    setshowTaskTab(false);
    setshowLogTab(false);
    if (tabName == "task") {
      setshowTaskTab(true);
    }
    if (tabName == "log") {
      setshowLogTab(true);
    }
  };

  const closePopup = () => {
    setIsReset(true);
    switchTabs("task");
    onPopupClose();
  };

  useEffect(() => {
    switchTabs("task");
  }, []);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="crmTaskPopup"
      aria-labelledby="crmTaskPopupLabel"
    >
      {/* Header design similar to SaveEcosystemPopup */}
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              task
            </span>{" "}
            {/* Using 'task' icon */}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="crmTaskPopupLabel"
            >
              {t("Task Details")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Manage and view task information")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={closePopup}
        ></button>
      </div>
      <div className="offcanvas-body p-0">
        <ul className="nav nav-tabs w-100 flex-nowrap fs-sm lh-1 fw-semibold text-center border-0 text-nowrap overflow-auto p-4 pb-0 shadow-sm">
          {/* task tab title */}
          <li className="nav-item flex-fill" role="presentation">
            <Link
              to="#"
              className={
                selectedTaskId
                  ? `text-black d-block px-3 py-3 position-relative ${
                      showTaskTab && "active"
                    }`
                  : `text-black d-block px-3 py-3 position-relative`
              }
              onClick={() => {
                switchTabs("task");
              }}
            >
              {t("Tasks Details")}
            </Link>
          </li>
          {/* log tab title */}
          {selectedTaskId && (
            <li className="nav-item flex-fill" role="presentation">
              <Link
                to="#"
                className={`text-black d-block px-3 py-3 position-relative ${
                  showLogTab && "active"
                }`}
                onClick={() => {
                  switchTabs("log");
                }}
              >
                {t("Logs")}
              </Link>
            </li>
          )}
        </ul>
        <div className="tab-content p-4" id="myTabContent">
          {/* task view tab */}
          {showTaskTab && (
            <CrmTaskTab
              selectedModuleSlug={selectedModuleSlug}
              moduleName={moduleName}
              contactId={contactId}
              leadId={leadId}
              selectedTaskId={selectedTaskId}
              setSelectedTaskId={setSelectedTaskId}
              afterPopupClose={afterPopupClose}
              isReset={isReset}
              setIsReset={setIsReset}
              setShowAlert={setShowAlert}
              setAlertMessage={setAlertMessage}
              setMessageType={setMessageType}
            />
          )}

          {/* log tab */}
          {selectedTaskId && showLogTab && (
            <CrmLogTab selectedTaskId={selectedTaskId} />
          )}
        </div>
      </div>
    </div>
  );
};

export default CrmTaskPopup;
